/* Very small markdown → HTML for AI docs. Handles headings, bold/italic, lists, tables. */
export function renderMarkdown(md) {
  if (!md) return "";
  let s = md.replace(/\r\n/g, "\n");
  // escape HTML
  s = s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

  // tables (very basic)
  s = s.replace(/((?:^\|.+\|\n)+)/gm, (m) => {
    const rows = m.trim().split("\n").filter((r) => r.trim().startsWith("|"));
    if (rows.length < 2) return m;
    const cells = (r) => r.trim().replace(/^\|/, "").replace(/\|$/, "").split("|").map((c) => c.trim());
    const header = cells(rows[0]);
    const isSep = /^\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)+\|?$/.test(rows[1]);
    const bodyStart = isSep ? 2 : 1;
    const th = header.map((h) => `<th>${h}</th>`).join("");
    const trs = rows.slice(bodyStart).map((r) => `<tr>${cells(r).map((c) => `<td>${c}</td>`).join("")}</tr>`).join("");
    return `<table><thead><tr>${th}</tr></thead><tbody>${trs}</tbody></table>`;
  });

  // headings
  s = s.replace(/^### (.*)$/gm, "<h3>$1</h3>");
  s = s.replace(/^## (.*)$/gm, "<h2>$1</h2>");
  s = s.replace(/^# (.*)$/gm, "<h1>$1</h1>");

  // bold + italic
  s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  s = s.replace(/\*(.+?)\*/g, "<em>$1</em>");
  s = s.replace(/`([^`]+)`/g, "<code>$1</code>");

  // lists
  s = s.replace(/(?:^|\n)((?:[-*] .+\n?)+)/g, (m, block) => {
    const items = block.trim().split("\n").map((l) => l.replace(/^[-*] /, "")).map((x) => `<li>${x}</li>`).join("");
    return `\n<ul>${items}</ul>\n`;
  });
  s = s.replace(/(?:^|\n)((?:\d+\. .+\n?)+)/g, (m, block) => {
    const items = block.trim().split("\n").map((l) => l.replace(/^\d+\. /, "")).map((x) => `<li>${x}</li>`).join("");
    return `\n<ol>${items}</ol>\n`;
  });

  // paragraphs
  s = s
    .split(/\n{2,}/)
    .map((p) => (/^<(h\d|ul|ol|table|pre|blockquote)/.test(p.trim()) ? p : `<p>${p.replace(/\n/g, "<br/>")}</p>`))
    .join("\n");

  return s;
}
